// @flow

import { put, takeLatest } from 'redux-saga/effects'
import { fetchTags } from '../stores/tags'
import { fetchCustomers } from '../stores/customersStore'
import type { Action } from '../types'

export const FETCH_INITIAL_DATA = 'opinary/FETCH_INITIAL_DATA'

export function fetchInitialData(): Action {
  return {
    type: FETCH_INITIAL_DATA,
  }
}

export function* sagaFetchInitialData(action: Action): Generator<*, *, *> {
  yield put(fetchCustomers())
  yield put(fetchTags())
}

export function* sagaRepeatedlyFetchInitialData(): Generator<*, *, *> {
  yield takeLatest(FETCH_INITIAL_DATA, sagaFetchInitialData)
}



// WEBPACK FOOTER //
// ./src/sagas/fetchInitialData.js